import i18n from 'modules/core/lib/i18n'

export const getEmployeeCountCopy = (count: number) => {
  return i18n.tp('common.employee_count', {
    count,
  })
}

export const getShiftCountCopy = (count: number) => {
  return i18n.tp('shift_management.shifts_selected', {
    count,
  })
}

export const getVerbCountCopy = (count: number) => {
  return count === 1
    ? i18n.t('shift_management.conflict.modal_verb')
    : i18n.t('shift_management.conflict.modal_verb_2')
}

export const getRestDayCountCopy = (count: number) => {
  return i18n.tp('shift_management.rest_days_selected', {
    count,
  })
}
